<div class="result_cls">
  <div class="result_title">
    DL离职申请
  </div>
  <div class="result_content">
    <Result [img]="img2" [title]="'提交成功'" [message]="messgeList">
      <ng-template #img2>
        <Icon class="spe" [type]="'check-circle'" [color]="'#1F90E6'"></Icon>
      </ng-template>
    </Result>
  <WhiteSpace></WhiteSpace>
  <WhiteSpace></WhiteSpace>
  <div Button [type]="'primary'" (click)="gobackHome()">返回首页</div>
  </div>
</div>
